import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Paper, Autocomplete, TextField, Grid } from '@mui/material'
import { Box, Stack, Checkbox, CircularProgress } from '@mui/material'
import { styled, Typography as MIUTypography } from '@mui/material'
import { CheckBoxOutlineBlank, CheckBox, Update } from '@mui/icons-material'
import { saveTemporalFeatures } from '../../redux/slices/Tree/treeFeatures'
import * as service from '../../services'
import Botton from '../BottonCustom'
import _ from 'lodash'

const KEY_OTHERS_IN_CATEGORY_TYPE = [86, 87, 88, 89, 90, 91, 92]
const icon = <CheckBoxOutlineBlank fontSize="small" />
const checkedIcon = <CheckBox fontSize="small" />
const COLOR_POPUP = 'var(--color-green)'
const COLOR_PRIMARY = 'var(--color-primary)'
const COLOR_WHITE = '#FFFAFA'

const styleDefaultButton = (bc, c, bcHover, cHover) => ({
  color: c,
  backgroundColor: bc,
  border: `1px solid ${c}`,
  width: '130px',
  fontSize: '12px',
  '&:hover': { backgroundColor: bcHover, color: cHover },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: '0.8em',
  fontWeight: 450,
  lineHeight: '18px',
  color: '#6A6A6A',
  paddingBottom: 6,
  paddingTop: 6,
}))

const stylePaper = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  listStyle: 'none',
  width: '100%',
  p: 0.5,
  m: 0,
}

const contentStyle = {
  width: '100%',
  height: '100%',
  textAlign: 'center',
}

const InputGroup3 = ({ data, editable, idcategory }) => {
  const dispatch = useDispatch()
  const [filterList1, setSelectedList] = React.useState(data)
  const [options, setOptions] = React.useState(null)
  const [inputControled, setInputControled] = React.useState(null)
  const temporalFeature = useSelector(state => state.treeFeatures.temporal)

  let inputDefault = null
  _.forEach(filterList1, obj => {
    if (_.includes(KEY_OTHERS_IN_CATEGORY_TYPE, obj.typecategory)) {
      const temporalValue = _.find(temporalFeature, ['typecategory', obj.typecategory])
      inputDefault = {
        value: inputControled ?? temporalValue?.initvalue ?? obj?.initvalue ?? '',
        label: obj.label,
      }
    }
  })

  const propsForInput = {
    value: inputDefault?.value,
    label: inputDefault?.label,
    onChange: e => setInputControled(_.trimStart(e.target.value)),
    variant: 'outlined',
    size: 'small',
    InputProps: { readOnly: !editable },
    helperText: 'Ingrese no más de 75 caracteres',
  }

  function deleteItemsToCurrentState(currentState, removeIds) {
    _.forEach(removeIds, idrm => _.remove(currentState, o => o.typecategory === idrm))
  }

  function removeChipBefore(typectgy_list, selected_list) {
    let remove = []
    _.forEach(typectgy_list, value => {
      if (!_.includes(selected_list, value)) remove.push(value)
    })
    return remove
  }

  function addItemsToCurrentState(currentState, addIds) {
    _.forEach(addIds, idadd => {
      let item = _.find(options, ['typecategory', idadd])
      currentState.push(item)
    })
  }

  function updateInput(currentState) {
    let othersItem = {}
    const wordWithoutSpaces = _.trim(inputControled)
    if (!Boolean(wordWithoutSpaces)) return

    _.forEach(KEY_OTHERS_IN_CATEGORY_TYPE, keyId => {
      const obj = _.find(filterList1, ['typecategory', keyId])
      if (Boolean(obj)) othersItem = { ...obj }
    })
    othersItem.initvalue = wordWithoutSpaces
    const index = _.findIndex(currentState, ['typecategory', othersItem.typecategory])
    if (index !== -1) currentState[index] = othersItem
  }

  function isDisable() {
    let disabled = true
    if (!Boolean(filterList1.length)) {
      const deletedItems = removeChipBefore(
        _.map(data, 'typecategory'),
        _.map(filterList1, 'typecategory')
      )
      if (deletedItems.length) disabled = false
      return disabled
    }
    if (!Boolean(inputDefault)) return (disabled = false)
    if (!Boolean(inputControled)) {
      const text = _.trim(propsForInput.value)
      if (text.length > 0 && text.length < 75) disabled = false
      return disabled
    }
    if (inputControled?.length < 75) disabled = false
    return disabled
  }

  const handleSetUpButton = async () => {
    let currentState = [...temporalFeature]
    const typeCatListKey = _.map(data, 'typecategory')
    const selectedListKey = _.map(filterList1, 'typecategory')
    const onlyNewItems = _.difference(selectedListKey, typeCatListKey)
    const deletedItems = removeChipBefore(typeCatListKey, selectedListKey)
    deleteItemsToCurrentState(currentState, deletedItems)
    addItemsToCurrentState(currentState, onlyNewItems)
    updateInput(currentState)
    dispatch(saveTemporalFeatures(currentState))
  }

  const handleSelection = (event, newList) => setSelectedList(newList)
  const handelEqualValue = (option, value) => option.typecategory === value.typecategory

  React.useEffect(() => {
    service
      .getCTByCategory(idcategory)
      .then(response => setOptions(response))
      .catch(err => console.log('Error :>> ', err.message))
    return () => {
      setOptions(null)
    }
  }, [idcategory])

  if (!Boolean(options))
    return (
      <Box sx={contentStyle}>
        <Stack sx={{ color: 'green.600', alignItems: 'center', mt: '17vh' }} spacing={2}>
          <CircularProgress />
          <Box>Cargando...</Box>
        </Stack>
      </Box>
    )

  return (
    <Paper sx={stylePaper} component="ul">
      <Autocomplete
        multiple
        id={`checkbox-tag-llls`}
        value={filterList1}
        onChange={handleSelection}
        options={options}
        readOnly={!editable}
        getOptionLabel={option => option.label}
        isOptionEqualToValue={handelEqualValue}
        disableClearable
        noOptionsText="Esta opción no está disponible"
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              chechedicon={checkedIcon}
              style={{ marginRigh: 0 }}
              checked={selected}
            />
            {option.label}
          </li>
        )}
        style={{ width: '100%' }}
        renderInput={params => <TextField {...params} />}
      />
      {Boolean(inputDefault) && (
        <Box sx={{ py: 1, width: '100%' }}>
          <TextField {...propsForInput} />
        </Box>
      )}
      {editable && (
        <Grid item sx={{ pt: 2 }}>
          <Box sx={{ width: 'auto' }}>
            <Botton
              text="FIJAR"
              onClick={handleSetUpButton}
              variant="contained"
              startIcon={<Update />}
              styleButton={styleDefaultButton(
                COLOR_WHITE,
                COLOR_PRIMARY,
                COLOR_WHITE,
                COLOR_POPUP
              )}
              disabled={isDisable()}
            />
            <Typography>Fije los elementos antes de cambiar la pestaña.</Typography>
          </Box>
        </Grid>
      )}
    </Paper>
  )
}
export default InputGroup3
